#import "./TrainingCategoryFields.graphql"

query GetTrainingCategories($includeArchived: Boolean) {
  trainingCategories(includeArchived: $includeArchived) {
    ...TrainingCategoryFields
  }
}
